export { default as colorToHex } from './color-to-hex'
